import littleAdd from "./littleAdd";

littleAdd.install = function(Vue, opts = {}) {
  Vue.component(component.name, component);
};

/* 支持使用标签的方式引入 */
if (typeof window !== "undefined" && window.Vue) {
  window.Vue.component("littleAdd", littleAdd);
  // install(window.Vue);
}

export default littleAdd;



// WEBPACK FOOTER //
// ./src/my-plugins/index.js